import { render, staticRenderFns } from "./BackOrdersDetails.vue?vue&type=template&id=7a3eac03&scoped=true"
import script from "./BackOrdersDetails.vue?vue&type=script&lang=js"
export * from "./BackOrdersDetails.vue?vue&type=script&lang=js"
import style0 from "./BackOrdersDetails.vue?vue&type=style&index=0&id=7a3eac03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3eac03",
  null
  
)

export default component.exports